import { useCallback, useRef, useState } from "react";
import { NavLink, useNavigate } from "react-router-dom";
import { mainNav, utilityLinks, roleLinks } from "@/data/site";
import BottomSheet from "@/components/base/BottomSheet";

const bottomItems = [
  { label: "Ana Sayfa", href: "/", icon: "ri-home-5-line", end: true },
  { label: "Eğitimler", href: "/egitimler", icon: "ri-play-circle-line", end: false },
  { label: "Sınavlar", href: "/sinavlar", icon: "ri-file-list-3-line", end: false },
  { label: "Canlı Ders", href: "/canli-dersler", icon: "ri-live-line", end: false },
];

export default function MobileBottomNav() {
  const [open, setOpen] = useState(false);
  const triggerRef = useRef<HTMLButtonElement>(null);
  const close = useCallback(() => setOpen(false), []);
  const navigate = useNavigate();

  const goTop = () => {
    window.scrollTo(0, 0);
  };

  const handleNav = (href: string) => {
    navigate(href);
    goTop();
    setTimeout(() => close(), 120);
  };

  return (
    <>
      <nav
        className="lg:hidden fixed bottom-0 inset-x-0 z-40 bg-primary-950 border-t border-white/10"
        aria-label="Mobil ana menü"
        style={{ paddingBottom: "env(safe-area-inset-bottom, 0px)" }}
      >
        <div className="flex items-stretch h-16 max-w-md mx-auto">
          {bottomItems.map((item) => (
            <NavLink
              key={item.href}
              to={item.href}
              end={item.end}
              className={({ isActive }) =>
                `relative flex-1 min-w-0 flex flex-col items-center justify-center gap-0.5 transition-colors duration-200 ${
                  isActive ? "text-accent-300" : "text-white/60 hover:text-white"
                }`
              }
            >
              {({ isActive }) => (
                <>
                  <span className="w-5 h-5 flex items-center justify-center">
                    <i className={`${item.icon} text-lg`} aria-hidden="true"></i>
                  </span>
                  <span className="text-[11px] font-medium leading-none whitespace-nowrap">
                    {item.label}
                  </span>
                  <span
                    className={`absolute top-0 inset-x-3 h-0.5 rounded-full bg-accent-400 origin-center transition-transform duration-200 ${
                      isActive ? "scale-x-100" : "scale-x-0"
                    }`}
                    aria-hidden="true"
                  ></span>
                </>
              )}
            </NavLink>
          ))}

          <button
            ref={triggerRef}
            type="button"
            onClick={() => setOpen(true)}
            aria-expanded={open}
            aria-controls="mobile-menu-sheet"
            className="relative flex-1 min-w-0 flex flex-col items-center justify-center gap-0.5 text-white/60 hover:text-white transition-colors duration-200 cursor-pointer"
          >
            <span className="w-5 h-5 flex items-center justify-center">
              <i className="ri-menu-line text-lg" aria-hidden="true"></i>
            </span>
            <span className="text-[11px] font-medium leading-none whitespace-nowrap">Tümü</span>
          </button>
        </div>
      </nav>

      <BottomSheet
        open={open}
        onClose={close}
        title="Tüm menü"
        titleId="mobile-menu-title"
        id="mobile-menu-sheet"
        returnFocusRef={triggerRef}
      >
        <nav aria-label="Tüm menü gezinme" className="flex flex-col gap-0.5">
          {mainNav.map((item) => (
            <button
              key={item.href}
              type="button"
              onClick={() => handleNav(item.href)}
              className="flex items-center justify-between gap-3 px-3 py-3 -mx-3 rounded-md text-[15px] font-medium text-foreground-800 hover:bg-background-100 hover:text-primary-700 transition-colors text-left"
            >
              {item.label}
              <i className="ri-arrow-right-s-line text-foreground-400" aria-hidden="true"></i>
            </button>
          ))}
        </nav>

        <div className="mt-6 pt-5 border-t border-background-200">
          <p className="text-xs font-semibold uppercase tracking-wide text-foreground-400 mb-1">
            Yardım
          </p>
          <div className="flex flex-col">
            {utilityLinks.map((item) => (
              <button
                key={item.href}
                type="button"
                onClick={() => handleNav(item.href)}
                className="flex items-center gap-3 px-3 py-2.5 -mx-3 rounded-md text-[15px] text-foreground-700 hover:bg-background-100 hover:text-primary-700 transition-colors text-left"
              >
                {item.label}
              </button>
            ))}
          </div>
        </div>

        <div className="mt-6 pt-5 border-t border-background-200">
          <p className="text-xs font-semibold uppercase tracking-wide text-foreground-400 mb-1">
            Giriş
          </p>
          <div className="flex flex-col">
            {roleLinks.map((item) => (
              <button
                key={item.href}
                type="button"
                onClick={() => handleNav(item.href)}
                className="flex items-center gap-3 px-3 py-2.5 -mx-3 rounded-md text-[15px] text-foreground-700 hover:bg-background-100 hover:text-primary-700 transition-colors text-left"
              >
                <i className="ri-user-3-line text-foreground-400" aria-hidden="true"></i>
                {item.label}
              </button>
            ))}
          </div>
        </div>
      </BottomSheet>
    </>
  );
}